/* ===========================================
   PAWSGRIP - Cart Celebration
   Confetti animation when adding to cart
   =========================================== */

(function() {
  'use strict';

  const CartCelebration = {
    // Deben coincidir con las clases .confetti-piece--* definidas en custom-live.css
    confettiColors: ['purple', 'coral', 'white'],
    confettiCount: 20,
    isPlaying: false,
    throttleMs: 3000,
    container: null,

    init() {
      this.container = this.createContainer();
      document.body.appendChild(this.container);
      this.listenForCartAdd();
      window.addEventListener('beforeunload', () => this.cleanup());
    },

    createContainer() {
      const container = document.createElement('div');
      container.className = 'paws-cart-celebration';
      container.setAttribute('aria-hidden', 'true');
      return container;
    },

    listenForCartAdd() {
      document.addEventListener('cart:add', () => this.trigger());
    },

    trigger() {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mediaQuery.matches) return;

      if (this.isPlaying) return;
      this.isPlaying = true;

      this.createConfetti();
      this.shakeCart();

      setTimeout(() => {
        this.isPlaying = false;
      }, this.throttleMs);
    },

    createConfetti() {
      for (let i = 0; i < this.confettiCount; i++) {
        const confetti = document.createElement('div');
        confetti.className = `confetti-piece confetti-piece--${this.confettiColors[i % this.confettiColors.length]}`;
        confetti.style.left = `${Math.random() * 100}%`;
        confetti.style.animationDelay = `${Math.random() * 0.5}s`;
        confetti.style.animationDuration = `${2 + Math.random() * 2}s`;

        const size = 5 + Math.random() * 10;
        confetti.style.width = `${size}px`;
        confetti.style.height = `${size}px`;
        confetti.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';

        this.container.appendChild(confetti);

        setTimeout(() => {
          if (confetti.parentNode) {
            confetti.remove();
          }
        }, 4000);
      }
    },

    shakeCart() {
      const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('cart-updated');
        setTimeout(() => cartDrawer.classList.remove('cart-updated'), 500);
      }
    },

    cleanup() {
      if (this.container) {
        this.container.innerHTML = '';
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    CartCelebration.init();
  });
})();
